var _circle, _path, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.835,
    cy: 9.835,
    r: 7.00167,
    stroke: "#4A4D68",
    strokeWidth: 1.66667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75057 9.835C6.75057 7.77276 7.17029 5.94694 7.81001 4.66751C8.47465 3.33823 9.23865 2.83333 9.83474 2.83333C10.4308 2.83333 11.1948 3.33823 11.8595 4.66751C12.4992 5.94694 12.9189 7.77276 12.9189 9.835C12.9189 11.8972 12.4992 13.7231 11.8595 15.0025C11.1948 16.3318 10.4308 16.8367 9.83474 16.8367C9.23865 16.8367 8.47465 16.3318 7.81001 15.0025C7.17029 13.7231 6.75057 11.8972 6.75057 9.835Z",
    stroke: "#4A4D68",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.78345,
    y1: 7.43473,
    x2: 16.8864,
    y2: 7.43473,
    stroke: "#4A4D68",
    strokeWidth: 1.66667
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.78345,
    y1: 12.1357,
    x2: 16.8864,
    y2: 12.1357,
    stroke: "#4A4D68",
    strokeWidth: 1.66667
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/Website.4105eaab92aa32c65d230ceaaf6357cf.svg";
export { ForwardRef as ReactComponent };